import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import theme from 'src/components/themes/DefaultTheme';
import { Movie } from 'src/lib/movieinfo/movieinfotypes';
import styled from 'src/lib/styles/css';
import { format, parseISO } from "date-fns";
import locale from "date-fns/locale/nb";
import WatchlistActionButton from 'src/components/kommendefilmer/WatchlistActionButton';
import withWatchlistState from 'src/components/filmwebid/withWatchlistState';

//#region [Props]
type KommerTextRowProps = {
	dateFormat: "thisweek" | "thisyear" | "year";
	film: Movie;
};
//#endregion

//#region [Component]
export default function KommerTextRow({ dateFormat, film }: KommerTextRowProps) {
	if (!film.premiere) {
		return null;
	}
	const premDate = parseISO(film.premiere);
	let dateLabel: string;
	if (film.isPremiereConfirmed) {
		switch (dateFormat) {
			case "thisyear":
			case "thisweek":
				dateLabel = format(premDate, "EEEE dd. MM", { locale });
				break;
			case "year":
				dateLabel = format(premDate, "dd.MM.yyyy", { locale });
				break;
		}
	} else {
		dateLabel = format(premDate, "MMM. yyyy");
	}

	return <SRowArticle>
		<STitleLink to={`/film/${film.mainVersionId}`}><SMovieTitle>{film.title}</SMovieTitle></STitleLink>
		<SPremiere>{dateLabel}</SPremiere>
		<SWLSWatchlistButton edi={film.mainVersionId} hideLabel/>
	</SRowArticle>;
}
//#endregion

const WLSWatchlistButton = withWatchlistState(WatchlistActionButton);

//#region [Styles]
const SRowArticle = styled.article`
	display: grid;
	grid-template-columns: 5fr 3.6fr 0.5fr;
	grid-gap: 8px;
	align-items: center;
	height: 35px;
	background-color: var(--buttoncolor);
	border-radius: 4px;
	padding: 5px 10px;
	margin-bottom: 5px;
	color: var(--textcolor);

	@media (min-width: 550px) {
        /*@media (orientation: landscape) {*/
        grid-template-columns: 6fr 2.6fr 0.3fr;
    }
`;

const STitleLink = styled(FilmwebLink)`
	text-decoration: none;
	overflow: hidden;
`;

const SMovieTitle = styled.h1`
	font-size: ${theme.fonts.tittelXXS.size};
	color: var(--textcolor);
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	width: 150px;


	@media (min-width: 550px) {
		width: auto;
	}
`;

const SPremiere = styled.div`
	font-size: ${theme.fonts.tittelXXS.size};
	text-align: right;
	text-transform: capitalize;
`;

const SWLSWatchlistButton = styled(WLSWatchlistButton)`
	color: var(--textcolor);
	background: transparent;
	padding: 0;
	margin: 0;

	svg {
		width: 1em;
	}
`;
//#endregion